import React from 'react';
import { useParams } from 'react-router-dom';
import PDFViewer from '../components/PDFViewer';
import { validateRecordId, validatePath, generatePDFUrl } from '../utils/pdfUtils';

const Viewer: React.FC = () => {
  const params = useParams<{ recordId?: string; path?: string }>();
  
  // Handle different URL patterns
  let recordId: string | undefined;
  let path: string | undefined;
  
  if (params.recordId && params.path) {
    // Path-based URL: /offers/recXXXX
    recordId = params.recordId;
    path = params.path;
  } else if (params.recordId && !params.path) {
    // Direct record ID: /recXXXX
    recordId = params.recordId;
    path = undefined;
  } else {
    // Invalid URL
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif'
      }}>
        <h3>Invalid URL</h3>
        <p>Please provide a valid record ID in the URL.</p>
      </div>
    );
  }

  // Validate record ID
  if (!validateRecordId(recordId)) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif'
      }}>
        <h3>Invalid Record ID</h3>
        <p>The record ID "{recordId}" is not in the correct format.</p>
      </div>
    );
  }

  // Validate path if provided
  if (path && !validatePath(path)) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem',
        fontFamily: 'system-ui, sans-serif'
      }}>
        <h3>Invalid Path</h3>
        <p>The path "{path}" contains invalid characters.</p>
      </div>
    );
  }

  // Generate the PDF URL using the utility function
  const pdfUrl = generatePDFUrl(recordId, path);
  
  // Debug logging
  console.log('Viewer - recordId:', recordId);
  console.log('Viewer - path:', path);
  console.log('Viewer - generated pdfUrl:', pdfUrl);

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      fontFamily: 'system-ui, sans-serif'
    }}>
      {/* Minimal header - removed since enhanced viewer has its own toolbar */}
      
      {/* PDF viewer takes full remaining space */}
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <PDFViewer 
          recordId={recordId}
          url={pdfUrl}
          onLoad={() => {/* PDF loaded successfully */}}
          onError={(error: Error) => {
            console.error('PDF load error:', error.message);
          }}
        />
      </div>
    </div>
  );
};

export default Viewer; 